var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"noaccess"},[_c('h1',[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.dashboard.login')))]),_c('v-btn',{staticClass:"mx-2",attrs:{"x-large":"","color":"#004687"},on:{"click":function($event){return _vm.goBack()}}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }